import { Component, inject, Input } from "@angular/core";
import { Router } from "@angular/router";
import { UiKitModule } from "@app/ui-kit.module";
import { ConfirmModalComponent } from "@components/confirm-modal/confirm-modal.component";
import { GroupIdChipComponent } from "@components/group-number-chip/group-id-chip.component";
import { ToggleGroupVisibilityButtonComponent } from "@components/toggle-group-visibility-button/toggle-group-visibility-button.component";
import { FloorplanEventType } from "@domain/project/floorplan/floorplan-event";
import { ProductItemGroup } from "@domain/project/floorplan/product-item-group";
import { NavigationService } from "@domain/project/navigation.service";
import { ModalService } from "@odx/angular/components/modal";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";

@Component({
  selector: "app-created-group-menu",
  standalone: true,
  imports: [FloorplanMenuItemButtonsComponent, UiKitModule, ToggleGroupVisibilityButtonComponent, GroupIdChipComponent],
  templateUrl: "./created-group-menu.component.html",
  styleUrl: "./created-group-menu.component.scss",
})
export class CreatedGroupMenuComponent {
  private navigationService = inject(NavigationService);
  protected floorplanService = inject(FloorplanService);
  private router = inject(Router);

  @Input() group!: ProductItemGroup;
  @Input() isSelected: boolean = false;

  protected readonly tooltipTextEditGroup: string = $localize`:@@floorplan.button.editGroup:Gruppe bearbeiten`;
  protected readonly tooltipTextDeleteGroup: string = $localize`:@@floorplan.button.deleteGroup:Gruppe auflösen`;

  private readonly modalService = inject(ModalService);

  protected editGroup(group: ProductItemGroup) {
    const url = this.router.url;
    this.navigationService.toGroupConfiguration(this.floorplanService.selectedFloorplan.id, group.id, url);
  }

  protected deleteGroup() {
    this.modalService
      .open(ConfirmModalComponent, {
        data: {
          text: $localize`:@@modal.deleteGroup.askForConfirmation:Soll die Gruppe wirklich aufgelöst werden? Die sich darin befindlichen Produkte werden nicht gelöscht.`,
        },
      })
      .onClose$.subscribe(() => {
        const floorplan = this.floorplanService.selectedFloorplan;
        floorplan.project.removeGroup(this.group.id);
        floorplan.publishUpdate(FloorplanEventType.GROUP_DELETED, this.group);
      });
  }
}
